<ul class="pagination" *ngIf="vm$ | async as vm">
  <li *ngFor="let item of vm.pagination; trackBy: trackByPage" class="pagination__item">
    <a
      mat-button
      [attr.rel]="item.rel"
      class="pagination__item_link"
      routerLink="."
      [attr.aria-current]="currentPageNumber === item.number"
      [attr.aria-label]="
        currentPageNumber === item.number ? 'Page actuelle  Page ' + item.number : 'Aller à la page ' + item.number
      "
      [class.pagination__item_link--active]="currentPageNumber === item.number"
      [queryParams]="{ page: item.number }"
      queryParamsHandling="merge"
      (click)="pageClicked(item.number)"
    >
      {{ item.number }}
    </a>
  </li>
</ul>
